export default "__VITE_ASSET__wPhTWBVk__"